export default __webpack_public_path__ + "02c08aab440ae96d025fc9f0006abe81.png";